import React from "react";
import { Col, Row } from "reactstrap";
import FormInput from "../../../components/common/form/FormInput";
import FormInputSelect from "../../../components/common/form/FormInputSelect";

class EventForm extends React.Component {
  render() {
    return (
      <>
        <Row>
          <Col md="4">
            <FormInput
              name="title"
              className="form-control-label"
              id="title"
              placeholder="Enter Title"
              type="text"
              onChange={this.props.onChange}
              label="Event title"
              value={this.props.valueObj.title || ""}
              errorMsg={this.props.errorObj.title || ""}
            />
          </Col>
          <Col md="4">
              <FormInput
                  name="description"
                  className="form-control-label"
                  id="description"
                  placeholder="Enter Description"
                  type="text"
                  onChange={this.props.onChange}
                  label="Event Description"
                  value={this.props.valueObj.description || ""}
                  errorMsg={this.props.errorObj.description || ""}
              />
          </Col>
          <Col md="4">
              <FormInput
                  name="eventDateTime"
                  className="form-control-label"
                  id="eventDateTime"
                  placeholder="Enter Event DateTime"
                  type="datetime-local"
                  onChange={this.props.onChange}
                  label="Event DateTime"
                  value={this.props.valueObj?.eventDateTime || ""}
                  errorMsg={this.props.errorObj?.eventDateTime || ""}
              />
          </Col>
            <Col md="4">
                <FormInput
                    name="location"
                    className="form-control-label"
                    id="location"
                    placeholder="Enter Location"
                    type="text"
                    onChange={this.props.onChange}
                    label="Event Location"
                    value={this.props.valueObj.location || ""}
                    errorMsg={this.props.errorObj.location || ""}
                />
            </Col>
            <Col md="4">
                <FormInput
                    name="organizer"
                    className="form-control-label"
                    id="organizer"
                    placeholder="Enter Organizer Name"
                    type="text"
                    onChange={this.props.onChange}
                    label="Event Organizer"
                    value={this.props.valueObj.organizer || ""}
                    errorMsg={this.props.errorObj.organizer || ""}
                />
            </Col>
            <Col md="4">
                <FormInput
                    name="organizerContact"
                    className="form-control-label"
                    id="organizerContact"
                    placeholder="Enter Organizer Contact / Address"
                    type="text"
                    onChange={this.props.onChange}
                    label=" Organizer Contact / Address"
                    value={this.props.valueObj.organizerContact || ""}
                    errorMsg={this.props.errorObj.organizerContact || ""}
                />
            </Col>
        </Row>
      </>
    );
  }
}

export default EventForm;
